<template>
  <div class="sidebar-cart-item" v-if="item">
    <div class="columns is-gapless">
      
      <div class="product-tile__left column sm-70-width">
        <div class="sidebar-cart-tile-wrapper">
          <div class="product-tile__thumb-wrapper">
            <a href="#" @click.prevent="gotoProductDetailPage(item)">
              <div>   
                <span class="cart-item-sale-tag is-size-11 text-white" v-if="variantHasSalePrice(item.selected_variant)">
                  {{ variantSalePercentage(item.selected_variant) }}
                </span>
                <div :class="'sidebar-cart-thumbnail' + (variantHasSalePrice(item.selected_variant) ? ' has-sale-tag' : '')">
                  <img v-if="item.product_image" :src="item.product_image+'?d=200x200'" :alt="item.product_name">
                  <img v-else src="@/assets/img/leaf.png" :alt="item.product_name">
                </div>
              </div>
            </a>
          </div>

          <div class="product-tile__info">
            <div class="product-tile__brand mb5">
              <span class="is-uppercase is-size-10 has-text-weight-medium" v-if="item.brand_name && (item.brand_name != 'No Brand')">{{ item.brand_name }}</span>
            </div>
            <router-link class="product-tile__brand mb-5" :to="{ name: 'LocationProductDetail',  params: { 
                business_slug: $route.params.business_slug,
                store_slug: $route.params.store_slug, 
                product_id: item.location_product_id, 
              },
              query: $route.query 
            }">
              <h3 class="product-tile__name is-size-12 has-text-weight-semibold cart-page-item-name">{{ item.product_name }}</h3>
            </router-link>
          
            <div class="product-tile__brand">
              <h3 class="product-tile__name is-size-11 cart-page-item-name">Variant: {{item.selected_variant.size }}</h3>
            </div>
          </div>
        </div>
      </div>


      <div class="product-tile__right column sm-30-width">
        <div class="columns is-gapless">
          <div class="column">
            <div class="level-right">
              <div class="is-flex-direction-column">
                <p class="has-text-right is-size-16 has-text-weight-bold has-text-dark">${{ item.price.toFixed(2) }}</p>
                <p class="sidebar-cart-thc-cbd has-text-right is-size-11 has-text-dark" v-if="thc">
                  THC: 
                  <span class="has-text-dark">{{ thc }}</span> 
                </p>
                <p class="sidebar-cart-thc-cbd has-text-right is-size-11 has-text-dark" v-if="cbd">
                  CBD: 
                  <span class="has-text-dark" >{{ cbd }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="is-flex sidebar-cart-item-actions">
      <a href="#" @click.prevent="removeItem()" class="mt10 text-secondary hover-opacity-7 hover-text-seconday has-text-weight-bold is-size-13">REMOVE</a>
      <div class="quantity-block is-width-xs mb0">
        <button value="-" @click="decreaseQty" class="button bg-secondary hover-opacity-7 minus is-borderless"><i class="fas fa-minus"></i></button>
        <div class="field mb0">
          <div class="control disable-click-event">
            <input class="input is-shadowless pointer-none" type="number" v-model="qty" value="1">
            <span v-text="qty" class="display-qty min-width-100 has-text-weight-bold has-text-dark"></span>
          </div>
        </div>
        <button  @click="increaseQty" value="+" class="button bg-secondary plus is-borderless hover-opacity-7">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'CartItem',
  data() {
    return {
      qty: 1,
    };
  },
  
  props: ['item'],

  mounted() {
    this.qty = this.item.unit;
  },
  
  computed: {
    ...mapGetters({
      vg_weightOnCart: "cart/cartWeight",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_selectedStore: "location/selected",
    }),
    product_form() {
      return Env.product_form;
    },
    plant_type() {
      return Env.product_type;
    },
    thc() {
      return Helpers.getTHCValueForCart(this.item);
    },
    cbd() {
      return Helpers.getCBDValueForCart(this.item);
    },
  },

  methods: {
    /**
     * Go to product details
     */
    gotoProductDetailPage(item) {
      bus.$emit('open-sidebar-cart', false);
    
      this.$router.push({
        name: 'LocationProductDetail',  
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug ? this.$route.params.store_slug : this.vg_selectedStore.slug, 
          product_id: item.location_product_id, 
        },
        query: this.$route.query
      })
    
    },
    /**
     * Remove item
     */
    removeItem() {
      bus.$emit('show-modal-remove-cart-item', {
        modal: true,
        product: this.item,
      });
    },
    /**
     * Increase quantity
     */
    increaseQty: async function(event) {
      if(event.detail && event.detail != 1){
        // prevent fast multiple clicks
        return false;
      } 
      // before increase check if can increase within limit ot not
      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit)){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
      } else {
        let totalQtyAfterAdd = this.qty + 1;
        let maxQtyCanAdd = parseInt(this.item.selected_variant.no_of_units - this.item.selected_variant.inventory_threshold); // gives no of item that can be added
        if(totalQtyAfterAdd > maxQtyCanAdd){
          // reject cannot add qut more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message:  Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        }  

        let newWeight = parseFloat(this.item.weight) + parseFloat(this.vg_weightOnCart)
        if(newWeight >  parseFloat(this.vg_cannabisLimit) ){
          this.va_spinner(false);
          bus.$emit('show-modal-cart-limit-exceed', {
            overWeight: newWeight.toFixed(2),
            modal: true,
          });
        } else {
          this.item.unit++;
         let res = await this.updateCartItem();
          if(res && this.$store.getters.getLoggedInUserToken){
            // on add +1 
            var obj = _.clone(this.item);
            obj.unit = 1;
            VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
            // Add cart item, G tracking add to cart
          } else {
            setTimeout(() => {
              this.va_spinner(false);
            }, 1000)
          }
          this.GtagAddRemoveItem('add_to_cart');
        }
      }
    },
    /**
     * Decrease quantity
     */
    decreaseQty: async function (event) {
    // decreaseQty() {
      if(event.detail && event.detail != 1){
        // prevent fast multiple clicks
        return false;
      } 

      if(this.item.unit == 1){
        // remove item from cart immediately without return confirm
        this.removeItemNow(this.item);
      } else if (this.item.unit > 1){
        this.item.unit--;
        let res = this.updateCartItem();
        if(res && this.$store.getters.getLoggedInUserToken){
          VboutApis.removeCartItem({
            cartid: this.$store.getters['cart/id'],
            productid: this.item.id,
            variation: { 
              variation_id: this.item.selected_variant.id, 
            },
          }, this.vg_selectedStore.id);
        } else {
            setTimeout(() => {
              this.va_spinner(false);
            }, 1000)
          }
        // Remove cart item, G tracking add to cart
        this.GtagAddRemoveItem('remove_from_cart');
      }
       
    },
    
    /**
     * Gtag update add remove item
     */
     GtagAddRemoveItem(key){
       if(!key){
         return;
       }
       this.$gtag.event(key, { 
        items: [
          {
            id: this.item.location_product_id,
            name: this.item.product_name, 
            brand: this.item.brand_name ? this.item.brand_name : null,
            category: this.item.category_name ? this.item.category_name : null,
            variant: this.item.selected_variant.size ? this.item.selected_variant.size : null,
            quantity: parseInt(this.item.unit),
            price: this.item.price,
          }
        ]
      });
     },
     /**
     * Update cart item 
     */
    async updateCartItem() {
      this.va_spinner(true);
       //Clone the object and filter
      var obj = _.clone(this.item);
      obj.cart_item_id = this.item.id;
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
      if(res.status == 200){
        this.qty = this.item.unit; 
        return true;
      } else {
        return false;
      }
    },

    variantHasSalePrice(item) {
      if(parseFloat(item.sale_price) > 0 && (parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return true;
      }
      return false;
    },

    variantSalePercentage(item) {
      let salePercentData =  ((item.price-item.sale_price) / item.price)*100;
      return ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% off';
    },

    async removeItemNow(product) {
      // Hit an api to remove cart items
      let res = await CartApis.delete({
        cart_product_id: product.id,
        location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
      });
     
      if(res.status == 200){
        if(this.$store.getters.getLoggedInUserToken){
          // remove from vbout , for logged in user
          VboutApis.removeCartItem({ 
            cartid: this.$store.getters['cart/id'],
            productid: this.item.id,
            variation: { 
              variation_id: this.item.selected_variant.id, 
            },
          }, this.vg_selectedStore.id);
        }
        // G tracking remove cart item
        this.$gtag.event('remove_from_cart', { 
          items: [
            {
              id: product.location_product_id,
              name: product.product_name, 
              brand: product.brand_name ? product.brand_name : null,
              category: product.category_name ? product.category_name : null,
              variant: product.selected_variant.size ? product.selected_variant.size : null,
              quantity: parseInt(product.unit),
              price: product.price,
            }
          ]
        });
      }
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
     
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>